import './App.scss';
import React, { useEffect, useState } from 'react'

function App({ settings }) {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(settings.url)
      const parsedResponse = await response.text()
      const jsonData = JSON.parse(parsedResponse.substring(47).slice(0, -2));
      const colz = [];
      //Extract column labels
      jsonData.table.cols.forEach((heading) => {
        if (heading.label) {
          let column = heading.label;
          colz.push(column);
        }
      })
      //extract row data:
      jsonData.table.rows.forEach((rowData) => {
        const row = {};
        colz.forEach((ele, ind) => {
          row[ele] = (rowData.c[ind] != null) ? rowData.c[ind].v : '';
        })
        data.push(row);
      })
      setData(data)
      setIsLoading(false)
    }
    fetchData()
  }, [data, settings.url])

  const Person = (props) => (
    <div className="list__person">
      <img className="person__image" src={props.Image} alt={props.Name} />
      <p className="person__name">{props.Name}</p>
      <p className="person__networth">
        {props.Votes}
        <span>Votes</span>
      </p>
    </div>
  )

  Person.defaultProps = {
    personImg:
      'https://specials-images.forbesimg.com/imageserve/5ab944eda7ea432fbc1d2d9c/416x416.jpg?background=000000&cropX1=0&cropX2=400&cropY1=0&cropY2=400'
  }

  const List = props => (
    <div className="list">
      {data.map((person, index) => (
        <Person
          key={index}
          Image={person.Image}
          Name={person.Name}
          Votes={person.Votes}
        />
      ))}
    </div>
  )

  const Header = () => (
    <div className="header">
      <img
        className="header__icon"
        src="https://user-images.githubusercontent.com/23297041/55285200-a24e9b00-538f-11e9-8990-d49a162824d1.png"
        alt="header"
      />
      <h1 className="header__title">
        {settings.title}
        <span>Leaderboard</span>
      </h1>
    </div>
  )

  const LoadingIndicator = () => (
    <div className="loading-indicator">
      <div className="lds-dual-ring"></div>
    </div>
  )

  return (
    <div className="app">
      <Header />
      {isLoading && <LoadingIndicator />}
      <List />
    </div>
  );
}

export default App;
